/**
 * @flow
 * @relayHash 14646700ee900880f4f78b46bb5e6411
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedGLAccountsContainer_glAccounts$ref = any;
export type GLAccountSortField = "ACCOUNT_NUMBER" | "ACCOUNT_TYPE" | "CREATED_AT" | "NAME" | "UPDATED_AT";
export type GLAccountType = "ASSET" | "COGS" | "EQUITY" | "EXPENSE" | "LIABILITY" | "REVENUE";
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type SortDirection = "ASC" | "DESC";
export type GLAccountSort = {|
  field: GLAccountSortField,
  direction: SortDirection,
|};
export type ChartOfAccountsQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  sortBy?: ?GLAccountSort,
  accountTypes?: ?$ReadOnlyArray<GLAccountType>,
  isActive?: ?boolean,
|};
export type ChartOfAccountsQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
  |},
  +$fragmentRefs: PaginatedGLAccountsContainer_glAccounts$ref,
|};
export type ChartOfAccountsQuery = {|
  variables: ChartOfAccountsQueryVariables,
  response: ChartOfAccountsQueryResponse,
|};
*/


/*
query ChartOfAccountsQuery(
  $search: String
  $sortBy: GLAccountSort
  $accountTypes: [GLAccountType!]
  $isActive: Boolean
) {
  ...PaginatedGLAccountsContainer_glAccounts_4ty56k
  viewer {
    id
    permissions
  }
}

fragment PaginatedGLAccountsContainer_glAccounts_4ty56k on Query {
  glAccounts(first: 30, search: $search, sortBy: $sortBy, accountTypes: $accountTypes, isActive: $isActive) {
    edges {
      cursor
      ...ChartOfAccountsTable_glAccountEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ChartOfAccountsTable_glAccountEdges on GLAccountEdge {
  node {
    id
    accountNumber
    name
    description
    accountType
    normalBalance
    balance
    isActive
    isSystem
    parentAccount {
      id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "GLAccountSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "accountTypes",
    "type": "[GLAccountType!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isActive",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "viewer",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "permissions",
      "args": null,
      "storageKey": null
    }
  ]
},
v3 = {
  "kind": "Variable",
  "name": "accountTypes",
  "variableName": "accountTypes"
},
v4 = {
  "kind": "Variable",
  "name": "isActive",
  "variableName": "isActive"
},
v5 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v6 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v7 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ChartOfAccountsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      (v2/*: any*/),
      {
        "kind": "FragmentSpread",
        "name": "PaginatedGLAccountsContainer_glAccounts",
        "args": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ChartOfAccountsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "glAccounts",
        "storageKey": null,
        "args": (v7/*: any*/),
        "concreteType": "GLAccountConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "GLAccountEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "GLAccount",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "accountNumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "accountType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "normalBalance",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "balance",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isActive",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isSystem",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "parentAccount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "GLAccount",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "glAccounts",
        "args": (v7/*: any*/),
        "handle": "connection",
        "key": "PaginatedGLAccountsContainer_glAccounts",
        "filters": []
      },
      (v2/*: any*/)
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ChartOfAccountsQuery",
    "id": null,
    "text": "query ChartOfAccountsQuery(\n  $search: String\n  $sortBy: GLAccountSort\n  $accountTypes: [GLAccountType!]\n  $isActive: Boolean\n) {\n  ...PaginatedGLAccountsContainer_glAccounts_4ty56k\n  viewer {\n    id\n    permissions\n  }\n}\n\nfragment PaginatedGLAccountsContainer_glAccounts_4ty56k on Query {\n  glAccounts(first: 30, search: $search, sortBy: $sortBy, accountTypes: $accountTypes, isActive: $isActive) {\n    edges {\n      cursor\n      ...ChartOfAccountsTable_glAccountEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ChartOfAccountsTable_glAccountEdges on GLAccountEdge {\n  node {\n    id\n    accountNumber\n    name\n    description\n    accountType\n    normalBalance\n    balance\n    isActive\n    isSystem\n    parentAccount {\n      id\n      name\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '87f3d60a9e676c45d5de0c9c58f474df';
module.exports = node;
